import React from 'react';
import {Container, Row, Col} from 'reactstrap';
import img from "../../../assets/images/demos/smartly5.jpg";
import image1 from "../../../assets/images/Project/2-rasm.jpg";
import {useTranslation} from 'react-i18next';
import {appConfig} from '../../../config';

const Connect = () => {
    const {t} = useTranslation();

    return (
        <React.Fragment>
            <section className="section" id="wallet">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={6}>
                            <div className="text-start mb-5">
                                <h2 className="mb-3 lh-base text-capitalize">
                                    {t('t-schedule-question')} ?
                                </h2>
                                <p className="text-muted">
                                    {t('t-schedule-question-desc').split('{appName}')[0]}
                                    <span className="fw-semibold">{appConfig.appName}</span>
                                    {t('t-schedule-question-desc').split('{appName}')[1]}
                                </p>
                                <div className="vstack gap-2">
                                    <div className="d-flex align-items-start">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">
                                                {t('t-schedule-question1')}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-start">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">
                                                {t('t-schedule-question2')}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-start">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">
                                                {t('t-schedule-question3')}
                                            </p>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-start">
                                        <div className="flex-shrink-0 me-2">
                                            <div className="avatar-xs icon-effect">
                                                <div
                                                    className="avatar-title bg-transparent text-success rounded-circle h2">
                                                    <i className="ri-check-fill"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex-grow-1">
                                            <p className="mb-0">
                                                {t('t-schedule-question4')}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col lg={6} className="ps-1 ps-5">
                            <div className="text-center mb-5 animate__animated animte__bounce">
                                <img src={image1} alt="" className="img-fluid shadow-lg rounded-3"/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
}

export default Connect;